<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                    <template>
                        <section>
                            <b-button type="is-success"
                                      icon-left="plus-circle"
                                      @click="addNewAuthGroup">
                                Add New
                            </b-button>
                            <br>
                            <hr>
                            <b-table
                                    :data="isEmpty ? [] : dataAuthGroup"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    >



                                    <b-table-column  label="Name Auth." v-slot="props">
                                        {{ props.row.name }}
                                    </b-table-column>
                                    <b-table-column  label="Status" v-slot="props">
                                        <b-icon pack="fas" size="is-large"
                                                :icon="props.row.enable === true ? 'check-circle' : 'times-circle'"
                                                :style= "props.row.enable === true ? 'color: #42b983' : 'color: firebrick' " >
                                        </b-icon>

                                    </b-table-column>
                                    <b-table-column  label="#" v-slot="props">
                                        <b-button type="is-danger"
                                                  icon-right="pencil"  @click="wakeAddEditAuthGroup(props.row.id,props.row.name,props.row.enable)"/>
                                    </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>
                        </section>
                    </template>
                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="close"  >
                        Close
                    </b-button>
                </footer>
            </div>
           <AddEditAuthGroup   @close="loadAuthGroup"  :dataToChild="dataToChild" ref="AddEditAuthGroup" />
        </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios"
    import { getBaseURLforBackEnd  , getConfigAxios  }  from '@/utils.js'
    import AddEditAuthGroup from "./AddEditAuthGroup";
    import { mapState } from "vuex";


    
    export default {
        name: "AuthGroup",
        components:{
            AddEditAuthGroup ,
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            loadAuthGroup(){
                const vm = this
                this.isFullScreenLoading = true
                const datTo ={
                    "all" : true
                }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                axios.post(`${getBaseURLforBackEnd()}/api/listofauthgroup`,datTo,getConfigAxios())
                    .then((res)=>{
                        vm.dataAuthGroup = res.data
                    })
                    .finally(()=>{
                        vm.isFullScreenLoading = false
                    })
            },

            addNewAuthGroup(){
                this.dataToChild = {"mode":"insert" ,"id": null , "name": "","status" :true }
                this.$refs.AddEditAuthGroup.isComponentModalActive = true
                this.$refs.AddEditAuthGroup.hasRequire = false
            },
            wakeAddEditAuthGroup(id,name,status){
                this.dataToChild = {"mode":"edit" ,"id": id , "name": name,"status" :status }
                this.$refs.AddEditAuthGroup.isComponentModalActive = true
            },

            close(){
                this.isComponentModalActive  = false
            }
        },
        data(){
            return{
                isComponentModalActive : false,
                isFullScreenLoading : false,
                isEmpty: false,
                dataAuthGroup : [],
                dataToChild: {"mode":"" ,"id": null}
            }
        },
        watch:{
            isComponentModalActive : function (val) {
                if(val){
                    this.loadAuthGroup()
                }

            }
        }
    }
</script>

<style scoped>

</style>